import {Row, Col, Button, Modal, Form} from 'react-bootstrap';
import {useState, useEffect, useRef, useCallback} from 'react';
import { useCreateDeviceMutation, useUpdateDeviceMutation, useDeleteDeviceMutation } from '../../slices/devicesApiSlice';
import { toast } from 'react-toastify';
import { AgGridReact } from 'ag-grid-react'; 
import "ag-grid-community/styles/ag-grid.css"; 
import "ag-grid-community/styles/ag-theme-alpine.css"; 
import LanCellRender from './cellRenders/LanCellRender';
import EditDeviceModal from './modals/EditDeviceModal';
import DeleteButtonCellRender from './cellRenders/DeleteButtonCellRender';
import EditButtonCellRender from './cellRenders/EditButtonCellRender';
import PhoneUpload from './PhoneUpload';
import useDynamicHeight from '../../hooks/useDynamicHeight';

const SiteDevices = ({siteDevices, site}) => {

    const newDevice = {
        name: '',
        type: '',
        hostname: '',
        serial: '',
        firmware: '',
        mac: '',
        lanIP: '',
        wanIP: '',
        companyName: '',
        vendor: '',
        supportNumber: '',
        connType: '',
        location: '',
        site: site._id
    }
    const [createDevice, {isLoading, error}] = useCreateDeviceMutation();
    const [updateDevice] = useUpdateDeviceMutation();
    const [deleteDevice] = useDeleteDeviceMutation();
    const[device, setDevice] = useState(newDevice);
    const[devices, setDevices] = useState(siteDevices);
    const[submitAction, setSubmitAction] = useState();
    const [show, setShow] = useState(false);
    const [showError, setShowError] = useState(false);
    const [quickFilterText, setQuickFilterText] = useState('');
    const [phoneUploadVisible, setPhoneUploadVisible] = useState(false);
    const [gridContainerRef, gridHeight] = useDynamicHeight([phoneUploadVisible, devices]);
    const deviceRef = useRef();
    deviceRef.current = device;
    const devicesRef = useRef();
    devicesRef.current = devices;
    const gridRef = useRef();
  
    useEffect(() => {
        if(device){
            setDevice(device);
        }
    }, [device])

    useEffect(() => {
        if(devices){
            setDevices(devices);
        }
    }, [devices])

    const handleCloseError = () => {
        setShowError(false);
        setDevice(newDevice);
    }
       
    const handleClose = () => {
        setShow(false);
        setDevice(newDevice);
    }
    const handleShow = (e) => {
        setSubmitAction(() => createDeviceHandler);
        setShow(true);
    }

    const onChange = event => {
        const {name, value} = event.target;
        setDevice(prevState => ({
            ...prevState,
            [name]:value
        }));
    }

    const onGridReady = (params) => {
        gridRef.current = params.api;
      };

    const createDeviceHandler = async () => {
        setShow(false);
        const currDevice = deviceRef.current;
        try{
            const res = await createDevice(currDevice).unwrap();
            toast.success(res.message);
            setDevices(devices => [...devices, res.addedDevice])
            setDevice(newDevice);
        }catch (error){
            toast.error(error?.data?.message || error.error);
        }
    }
 
    const updateDeviceHandler = async () => {
        const currDevice = deviceRef.current;
        const updateDevices = []
        const res = await updateDevice(currDevice).unwrap();
        devicesRef.current.map(arrdevice => {
            if(arrdevice._id == res.updatedDevice._id){
                updateDevices.push(res.updatedDevice)
            } else {
                updateDevices.push(arrdevice);
            }
        });
        setDevices(updateDevices);
        setShow(false);
        toast.success(res.message);
    }



    const removeDeviceHandler = async () => {
        const currDevice = deviceRef.current;
        const res = await deleteDevice(currDevice._id).unwrap();
        const index = devices.findIndex(device => device._id === currDevice._id);
        if (index !== -1) {
          const newArray = [...devices.slice(0, index), ...devices.slice(index + 1)];
          setDevices(newArray);
        }
        setShowError(false);
        setDevice(newDevice);
        toast.success(res.message);
    }

    const [colDefs, setColDefs] = useState([
        {field: "name"},
        {field: "type"},
        {field: "hostname"},
        {field: "lanIP", cellRenderer: LanCellRender},
        {field: "location"},
        {field: "vendor"},
        {field: "supportNumber"},
        {headerName: 'Edit', field: 'actions', width:80, cellRenderer: EditButtonCellRender,
            cellRendererParams: {
                onEdit: (deviceId) => {
                    devicesRef.current.map(device => {
                        if(device._id === deviceId._id){
                            setDevice(device);
                            setSubmitAction(() => updateDeviceHandler)
                            setShow(true);
                            
                        }
                       })
                }
            }
        },
        {headerName: 'Delete', field: 'delete', cellRenderer: DeleteButtonCellRender,
            cellRendererParams: {
                onDelete: (deviceId) => {
                    devicesRef.current.map(device => {
                        if(device._id === deviceId){
                            setDevice(device);
                            setShowError(true);
                        }
                       })
                }
            }
        }
    ]);

    const onExportClick = useCallback(() => {
        const fileName = site.name + '_devices_' + Date.now() + ".csv";
        gridRef.current.exportDataAsCsv({fileName: fileName});
      }, []);


      const onQuickFilterChange = (event) => {
        setQuickFilterText(event.target.value);
        if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.setQuickFilter(event.target.value);
        }
      };
    
   

    return  isLoading ? (
        <h2>Loading</h2>
    ): error ? (
        <div>{error?.data?.message || error.error}</div>
    ) : (
        <>


        <Modal show={showError} onHide={handleCloseError} centered>
            <Modal.Header closeButton>
            <Modal.Title>Delete Device</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure you want to delete this device?</Modal.Body>
            <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseError}>
                Close
            </Button>
            <Button variant="danger" onClick={removeDeviceHandler}>
                Delete
            </Button>
            </Modal.Footer>
        </Modal>


        <PhoneUpload siteId={site._id} visible={phoneUploadVisible} />

        <Row className='align-items-right'>
            <Col className='text-end'>
                <Button className='btn-sm m-3 modalAddButton' data-type='modalAddButton' onClick={handleShow}>
                    Add Device
                </Button>
                <Button className='btn-sm m-3 modalAddButton' onClick={onExportClick}>Export to CSV</Button>
              
            </Col>
        </Row>

        <Row>
            <Col sm={3}>
            <Form.Control
                type="text"
                placeholder="Filter"
                value={quickFilterText}
                onChange={onQuickFilterChange}
                className="mb-3"
            />
            </Col>
      </Row>


        <Row>
            <Col>
                <div ref={gridContainerRef} className="ag-theme-alpine" style={{ height: gridHeight }} >
                    <AgGridReact
                        ref={gridRef}
                        rowData={devices}
                        columnDefs={colDefs}
                        suppressExcelExport={true}
                        frameworkComponents={{
                            LanCellRender: LanCellRender,
                            EditButtonCellRenderer: EditButtonCellRender,
                            DeleteButtonCellRender: DeleteButtonCellRender
                            }}
                        onGridReady={onGridReady}
                        quickFilterText={quickFilterText}
                    />
                </div>
            </Col>
        </Row>
            {device && (
                <EditDeviceModal
                show={show}
                handleClose={handleClose}
                device={device}
                onChange={onChange}
                onSave={submitAction}
                />
            )}
                </>
    )
}

export default SiteDevices;
